import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[sparteFormInfo]'
})
export class FormInfoDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
